import { ServerDataType } from 'types/publishedAssets';
import { normalizeLocales } from './normalizeLocale';

export const determineAvailableLanguages = (serverData: ServerDataType) => {
  const { organization, theme, page, questionnaire, survey } = serverData;
  let availableLanguages = organization?.languages || theme?.languages;
  if (page) {
    availableLanguages = availableLanguages?.filter((language) => page.available_locales?.includes(language));
  }
  if (questionnaire) {
    const questionnaireLanguages = normalizeLocales(questionnaire.available_locales);
    availableLanguages = availableLanguages?.filter((language) => questionnaireLanguages.includes(language));
  }
  if (survey) {
    availableLanguages = availableLanguages?.filter((language) =>
      survey.languages?.map((surveyLanguage) => surveyLanguage.language_code)?.includes(language),
    );
  }
  return availableLanguages || [];
};
